import useAgentName from 'hooks/useAgentName'
import useThemeColors from 'hooks/useThemeColors'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import './style.css'

const AgentTypingIndicator = () => {
  const { t } = useTranslation()
  const { messageAuthorTheme } = useThemeColors()
  const { isTyping: isAgentTyping = false, userId: typingAgentId } = useSelector(state =>
    state.conversations.typingIndicators[state.conversations.activeConversation] || {}
  )
  const typingAgentName = useAgentName(typingAgentId)

  if (!isAgentTyping) {
    return null
  }

  return (
    <p aria-live="polite" style={messageAuthorTheme} className="agent-typing-indicator">
      {t('status.agentTyping', { agent: typingAgentName })}
    </p>
  )
}

export default AgentTypingIndicator
